import React from 'react';
import { motion } from 'framer-motion';
import { PageTransition } from '../components/PageTransition';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Play, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
const guests = [{
  name: 'Chris Horseman',
  title: "Owner, Horseman's Landscape",
  description: "Pain is something we all try to avoid, yet it's often the very thing that shapes us most. In this episode, The Process of Pain, we sit down with Chris Horseman of Horseman's Landscape to talk honestly about what pain looks like when it shows up in real life — not as a theory, but as a process.",
  initials: 'CH',
  episodeId: 1,
  website: 'https://horsemanslandscape.com',
  episodes: [{
    label: 'Listen to Episode',
    url: '#'
  }]
}, {
  name: 'Josh Phelps',
  title: 'Founder, First Response Water & Mold Removal',
  description: 'From the high-stakes world of law enforcement to the front lines of disaster restoration, Josh Phelps shares his journey of moving away from a life of performance and into a place of spiritual stillness. After years of trying to earn God\'s favor, a season of betrayal, divorce, and loss led Josh to the transformative call of Psalm 46:10: "Be still and know that I am God." His story is a testament to the power of divine protection and the beauty of restoration.',
  initials: 'JP',
  episodeId: 2,
  episodes: [{
    label: 'Listen to Episode',
    url: 'https://open.spotify.com/episode/77Ie7kgLCKcZGh7EBAtJl3?si=_nUsG9ebSHOZEg2QEHBZCA'
  }]
}, {
  name: 'Justin Hanneken',
  title: 'Executive Director, Ends of Earth Adventures',
  description: "Justin's mission takes him to the literal ends of the earth. He shares how adventure and faith collide, and why stepping into the unknown is where God does His best work.",
  initials: 'JH',
  episodeId: 3,
  episodes: [{
    label: 'Episode 3 — Part 1',
    url: 'https://open.spotify.com/episode/4n7iOViUYM8hg3L4P27v1U?si=9yeXgtkTSb-Lz69F0XpP1g'
  }, {
    label: 'Episode 4 — Part 2',
    url: 'https://open.spotify.com/episode/4Jci4PYyVQ7HoRSNHKKRBt'
  }]
}, {
  name: 'Andrew, Caleb & JJ',
  title: 'College Students',
  description: 'These three young men bring the energy, passion, and unfiltered faith of the next generation. They talk about navigating college life, peer pressure, and staying rooted in Christ when the world pulls in every direction.',
  initials: 'ACJ',
  episodeId: 4,
  episodes: [{
    label: 'Listen to Episode',
    url: 'https://open.spotify.com/episode/0GfsHrolJsi0UAOTYJmcP4?si=uqs65Xs0SEuw68MYC_VudA'
  }]
}, {
  name: 'Francisco Miyares Jr.',
  title: 'Missionary',
  description: "Francisco Miyares Jr. is a missionary who stepped away from a 15-year corporate career to follow God's call into full-time ministry. After years in the marketplace alongside high-level executives, he chose obedience over comfort, answering a call to fully dedicate his life toward advancing the Gospel and making a lasting impact for Christ.",
  initials: 'FM',
  episodeId: 6,
  episodes: [{
    label: 'Listen to Episode',
    url: 'https://open.spotify.com/episode/79QQTpd7sZaxeIXfE2f1hc?si=PaCFBAHXQSGADxmAsXB9yA'
  }]
}, {
  name: 'Jimmy Akers',
  title: 'Speaker & Storyteller',
  description: 'Jimmy Akers blends his experience of 19+ years of serving people at their most critical intersections in life and providing support to help improve their mental health, as a clean, funny, speaker and storyteller. Jimmy has spoken 1,000+ times around the world, and shares his struggles with anxiety, depression, loss and a suicide attempt.',
  initials: 'JA',
  episodeId: 8,
  episodes: [{
    label: 'Listen to Episode',
    url: 'https://open.spotify.com/episode/4YF0jNbcTWNam3nXdO88vS?si=Po7coKNCShyWl9Q6DB0Rkg'
  }]
}, {
  name: 'Lexi Loofboro',
  title: 'Hiking Director & Coach',
  description: 'Lexi Loofboro loves anything that brings together faith, health, and people. She is married to her husband, Ian Loofboro, and together they serve the world through coaching, and their stand is to be love, hope and transformation. As a Hiking Director, Lexi takes those same passions and leads others to step away from the everyday and into adventures with God!',
  initials: 'LL',
  episodeId: 8,
  episodes: [{
    label: 'Listen to Episode',
    url: 'https://open.spotify.com/episode/5goM61DmWoPhpbdWjrwgCQ?si=ff59ec03952841fa'
  }]
}, {
  name: 'The Schwartz Family',
  title: 'Wayne, Michelle, Rachel & Emma',
  description: 'The Schwartz family shares the story of an Oct. 13 car crash in rural Michigan that changed their lives in an instant. Wayne, Michelle, and their daughters Rachel and Emma open up about how a tragic accident became a powerful testimony of faith, family, and the abundant life found even in the darkest moments.',
  initials: 'SF',
  episodeId: 9,
  episodes: [{
    label: 'Episode 9 — Part 1',
    url: 'https://open.spotify.com/episode/4mIITXmQE29cGzkPj6i88B?si=g0AnVAUXThCAvBgQTeSZMw'
  }, {
    label: 'Episode 10 — Part 2',
    url: 'https://open.spotify.com/episode/4OpAP35TOjPU15p1UKkAX3?si=VcWO4svuTzqPdTwkY41L0w'
  }]
}, {
  name: 'Iskander',
  title: 'Musician & Missionary',
  description: 'Born Jesús Martínez in Venezuela, Iskander is a dynamic reggae musician and passionate missionary whose work spans music, ministry, and humanitarian outreach worldwide. Through his powerful sound, he conveys messages of love, hope, and faith—reaching audiences across cultures while serving marginalized communities, from the homeless to at-risk youth. Whether on stage or in the field, Iskander uses his music and faith to make a lasting impact, one song and one mission at a time.',
  initials: 'IS',
  episodeId: 11,
  episodes: [{
    label: 'Listen to Episode',
    url: 'https://open.spotify.com/episode/3bDtfcX8c7dRvH29wygmzB?si=7EqDTOw9TZqRwETk0tN6xA'
  }]
}, {
  name: 'Cody Grube',
  title: 'Founder, Streetlights Ministries',
  description: "Cody Grube is the founder of Streetlights Ministries, a powerful outreach dedicated to sharing the light of Christ on the streets with those who need it most. Inspired by Isaiah 35:5-9 and grounded in the call to love God and love your neighbor, Cody brings hope, healing, and the transformative message of the Gospel to the streets and beaches. His heart is to see lives changed through authentic encounters with God's love.",
  initials: 'CG',
  episodeId: 13,
  website: 'https://streetlightsministries.org/',
  episodes: [{
    label: 'Listen to Episode',
    url: 'https://open.spotify.com/episode/6rWWtBOJcpCSI2vC7eErcc?si=hwQCB_NoRfOqoL7to5EXqA'
  }]
}, {
  name: 'Matt Crosson',
  title: 'Worship Leader, Missionary & Father',
  description: 'Matt Crosson is a worship leader, missionary, and father whose life is a living testimony of faith in action. With a heart for leading others into the presence of God through worship and a calling that has taken him across the globe on the mission field, Matt brings a unique perspective on what it means to serve God while raising a family rooted in Christ. From pastoring and songwriting to biking across nations, his life points to Jesus wherever he goes.',
  initials: 'MC',
  episodeId: 14,
  episodes: [{
    label: 'Listen to Episode',
    url: 'https://open.spotify.com/episode/1VjWqTTxQ3OKNueDnMvmC1?si=vcW72IKKS3GDUNNRrbyw0Q'
  }]
}, {
  name: 'Erin Morrison',
  title: 'Ends Sailing Director, Ends Adventures',
  description: "Erin Morrison serves as the Ends Sailing Director for Ends Adventures. Erin felt called by God to pursue camp programs for at-risk youth, both overseas and locally. Having a background in biology, her heart is to use God's creation to show youth how deeply loved they are. Grounded in Romans 12:2, Erin talks about God's plan in providing Refuge for Erin going all in and not pursuing a life of comfort.",
  initials: 'EM',
  episodeId: 15,
  episodes: [{
    label: 'Listen to Episode',
    url: 'https://open.spotify.com/episode/63Dwqu74u1ipzyw1Lfk2BN?si=ec76414f26204827'
  }]
}, {
  name: 'Krista Klossner',
  title: "It's Okay to Not Be Okay",
  description: "Join us for a powerful two-part conversation with Krista Klossner as she shares her story of faith, surrender, and discovering that nothing is counted as a loss when you're walking with God. In Part 1, Krista opens up about the moments that shaped her journey and the truth that it's okay to not be okay. In Part 2, the conversation continues — going deeper into her story of faith, surrender, and the truth that nothing is counted as a loss when you're walking with God.",
  initials: 'KK',
  episodeId: 16,
  episodes: [{
    label: 'Episode 16 — Part 1',
    url: 'https://open.spotify.com/episode/5Ypjxx0MxrjnUAg47wlq9O?si=PNtQOn0NTIiRdFw0tc9wQw'
  }, {
    label: 'Episode 17 — Part 2',
    url: 'https://open.spotify.com/episode/7w8hZFEyNDiMk1ZtKYggMq?si=5h4g_NX2QlaCuCy-R6ysMg'
  }]
}, {
  name: 'Pastor Charlie Mitchell',
  title: 'Pastor & Founder, Maroon House',
  description: 'Pastor Charlie Mitchell shares his journey from growing up in Key West and Fort Myers, to losing his father to cancer at just 13 years old and stepping into adult responsibilities far too early. Charlie opens up about finding faith through youth ministry, missions work around the world, meeting his wife Erin in Copenhagen, and walking through deep loss, chronic illness, and a stage four kidney diagnosis that ultimately led to a life-saving transplant in 2023. His story is a powerful reminder that hope can be found in the middle of the storm.',
  initials: 'CM',
  episodeId: 18,
  episodes: [{
    label: 'Episode 18 — Hope in the Middle of the Storm',
    url: 'https://open.spotify.com/episode/5nLNKOKVfFp7UOUjvDl2Tx?si=Tzc-Tf3pRKSgTWEPxBTmzA'
  }]
}, {
  name: 'Mario Lara',
  title: 'The Occult to The Way',
  description: 'A powerful story of transformation. Mario Lara shares his journey out of the occult and into the life-changing truth of Jesus — The Way, The Truth, and The Life. An honest conversation about freedom, deliverance, and walking in the light.',
  initials: 'ML',
  episodeId: 19,
  episodes: [{
    label: 'Episode 19 — The Occult to The Way',
    url: 'https://open.spotify.com/episode/4SFsOtTWStlzdmHcWhF8zQ?si=r3Bvt6b-StqPczGEaWPJRw'
  }]
}, {
  name: 'Hannah Karius',
  title: 'Wrapped in the Cord, Held by Grace',
  description: "Hannah Karius shares how growing up in church gave her knowledge about Jesus, but motherhood and crisis led her into a real relationship with Him. Hannah recounts two terrifying birth experiences — including a code blue delivery during COVID lockdowns in New York and a second pregnancy where her baby was wrapped in the cord — and how God's grace held her family through it all. Her story is a powerful testimony to surrender, prayer, and the presence of God in life's most uncertain moments.",
  initials: 'HK',
  episodeId: 20,
  episodes: [{
    label: 'Episode 20 — Wrapped in the Cord, Held by Grace',
    url: 'https://open.spotify.com/episode/5dO8hOus1KUlbeUG8Jxqsb?si=jUKQZdlBRASSMaHgwJiLNA'
  }]
}, {
  name: 'Scott Anderson',
  title: "What's Your Problem",
  description: 'Scott Anderson speaks about being born with cerebral palsy — from lessons from his parents on not being a victim, to coming to faith and living in victory. Scott has spoken all around the world, sharing his love of Jesus to many nations while born with a disability. He lets nothing stop him from sharing the gospel. Scott also serves as the bridge between 4KIDS Southwest Florida and local faith communities, building church partnerships, recruiting foster families, and mobilizing volunteers and resources to care for children and teens in crisis.',
  initials: 'SA',
  episodeId: 21,
  website: 'https://4kids.us/about/the-need/',
  episodes: [{
    label: "Episode 21 — What's Your Problem",
    url: 'https://open.spotify.com/episode/2yCMgC8ziu25pxni8iOz7J?si=56eU2TrFSIWuLPVz56hWbg'
  }]
}];
export function GuestsPage() {
  return <PageTransition data-id="element-293">
      <div className="pt-24 pb-16 min-h-screen" data-id="element-294">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-295">
          <div className="text-center mb-16" data-id="element-296">
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-297">
              Meet Our Guests
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-298">
              Real people. Real stories. See the faces behind the voices.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-299">
            {guests.map((guest, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-300">
                <Card className="h-full bg-dark-700 border-dark-600 overflow-hidden" data-id="element-301">
                  <div className="p-8 flex flex-col h-full" data-id="element-302">
                    <div className="flex items-center space-x-4 mb-6" data-id="element-303">
                      <div className="w-16 h-16 rounded-full bg-dark-800 border-2 border-gold-500 flex items-center justify-center flex-shrink-0" data-id="element-304">
                        <span className="text-xl font-bold text-gold-500" data-id="element-305">
                          {guest.initials}
                        </span>
                      </div>
                      <div data-id="element-306">
                        <h3 className="text-2xl font-serif font-bold text-white" data-id="element-307">
                          {guest.name}
                        </h3>
                        <p className="text-gold-500 text-sm font-medium" data-id="element-308">
                          {guest.title}
                        </p>
                      </div>
                    </div>

                    <div className="w-full h-px bg-dark-600 mb-6" data-id="element-309"></div>

                    <p className="text-white/80 leading-relaxed mb-8 flex-grow" data-id="element-310">
                      {guest.description}
                    </p>

                    <div className="flex flex-col gap-3" data-id="element-311">
                      {guest.episodes.map((ep, epIndex) => <a key={epIndex} href={ep.url} target="_blank" rel="noopener noreferrer" data-id="element-312">
                          <Button variant="outline" className="w-full" leftIcon={<Play className="w-4 h-4" data-id="element-314" />} data-id="element-313">
                            {ep.label}
                          </Button>
                        </a>)}
                      {guest.website && <a href={guest.website} target="_blank" rel="noopener noreferrer" data-id="element-315">
                          <Button variant="ghost" className="w-full" leftIcon={<ExternalLink className="w-4 h-4" data-id="element-317" />} data-id="element-316">
                            Visit Website
                          </Button>
                        </a>}
                    </div>
                  </div>
                </Card>
              </motion.div>)}
          </div>
        </div>
      </div>
    </PageTransition>;
}